import React from "react";
import shortid from "shortid";
import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ProfilePhotosDialog from "../Profile/Modals/ProfilePhotosDialog";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

const WebsiteGalleryInstagram = () => {
	const classes = useStyles("Website");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const backgroundColor = "#F2F2F2"; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const width = 1200;
	const widthMobile = 420;
	const columns = 5; // 1-6
	const columnsMobile = 2; //hardcoded
	const rows = 2; // 1 - 6
	const limit = rows * columns;
	const height = width / columns;
	const heightMobile = 180; //hardcoded

	const header = `Explore our Instagram`;
	const subHeader = `@instagram`;
	const instagramURL = subHeader
		? `https://instagram.com/${subHeader.replace("@", "")}`
		: "#";

	const tagline = "";
	const textAlign = "center"; // left / center / right
	const lineBreak = true;
	const content = "";

	const itemData = [
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--4pkoGViv--/c_scale,f_webp,q_auto,w_600/v1/lessons/user-media/prod/approved/provider/5d93c15dcf60d475cb76de12/portfolio/OSVZ-AXBM/344988204_760090035706136_4194027227348569835_n.jpg",
			title: "Image",
			author: "author",
			cols: 1,
		},

		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--qfYZyCse--/c_scale,f_webp,q_auto,w_600/v1/lessons/user-media/prod/approved/provider/5d93c15dcf60d475cb76de12/portfolio/5Bq88LBQ1/Screen%20Shot%202024-01-23%20at%209.27.07%20AM.png",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--1hKMTTq1--/c_scale,f_webp,q_auto,w_600/v1/lessons/user-media/prod/approved/provider/5d93c15dcf60d475cb76de12/portfolio/09Fy_h4Uc/Screen%20Shot%202024-01-23%20at%209.28.31%20AM.png",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--ApQcre-N--/c_scale,f_webp,q_auto,w_600/v1/lessons/user-media/prod/approved/provider/5d93c15dcf60d475cb76de12/portfolio/Fi9Z9BgJx/Screen%20Shot%202024-01-23%20at%209.27.50%20AM.png",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--LBlbh47n--/c_scale,f_webp,q_auto,w_600/v1/lessons/user-media/prod/approved/provider/5d93c15dcf60d475cb76de12/portfolio/eGa4TWlEF/Screen%20Shot%202024-01-23%20at%209.30.08%20AM.png",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://img.youtube.com/vi/5lsjXCjQaAY/mqdefault.jpg",
			title: "Image",
			author: "author",
			cols: 1,
		},

		{
			img: "https://img.youtube.com/vi/0I2A4QGw2Ms/mqdefault.jpg",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://v4.mui.com/static/images/image-list/olive.jpg",
			title: "Image",
			author: "author",
			cols: 1,
		},
		{
			img: "https://v4.mui.com/static/images/image-list/breakfast.jpg",
			title: "Image",
			author: "author",
			cols: 1,
		},
	];

	return (
		<React.Fragment>
			{/* <ProfilePhotosDialog /> */}

			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={textAlign}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header}
										</Box>
									)}

									{subHeader && (
										<a href={instagramURL} target="_blank">
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										</a>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<div className={classes.websitePhotosBox}>
										<ImageList
											rowHeight={fullScreen ? heightMobile : height}
											cols={fullScreen ? columnsMobile : columns}
											gap={8}
										>
											{itemData.slice(0, limit).map((item) => (
												<ImageListItem
													key={item.img}
													cols={1}
													className={classes.photoListItem}
												>
													<img
														src={item.img}
														alt={item.title}
														className={classes.photoDialogPic}
														//onClick={viewPhoto(0)}
														loading="lazy"
														decoding="async"
														fetchpriority="auto"
													/>
												</ImageListItem>
											))}
										</ImageList>
									</div>

									<Box
										mt={15}
										textAlign={textAlign}
										justifyContent={textAlign}
										width={"100%"}
									>
										<Button
											size="large"
											color="primary"
											variant="contained"
											disableElevation
											className="columnButton"
											href={instagramURL}
											target="_blank"
										>
											See full feed
										</Button>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteGalleryInstagram;
